import type { NotificationReference as NotificationReferenceType } from '@/@types/notification'
import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'

export interface ReferenceItemProps extends HTMLAttributes<HTMLDivElement> {
	data: NotificationReferenceType | undefined
}

export default function NotificationReference({ data, ...props }: ReferenceItemProps) {
	return (
		<div
			css={css`
				width: 60px;
				max-height: 60px;
			`}
			{...props}
		>
			{data?.referenceImageUrl ? (
				<img
					width={60}
					height={60}
					loading="lazy"
					src={data.referenceImageUrl}
					css={css`
						width: 100%;
						height: 100%;
						object-fit: cover;
						border-radius: 4px;
						border: 1px solid var(--tint-pic-border, rgb(0 0 0 / 5%));
						overflow: hidden;
					`}
				/>
			) : (
				<div
					css={css`
						height: 100%;
						color: var(--tint-tertiary, #bfbfbf);
						font-size: 14px;
						font-weight: 400;
						line-height: 20px;
						overflow: hidden;
						text-overflow: ellipsis;
					`}
				>
					{data?.content}
				</div>
			)}
		</div>
	)
}
